import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	mode:'history',
  	routes: [
  	{
      path: '/',
      name: 'index',
     	component: resolve => require(['@/page/index/index'], resolve)
    },
    {
      path: '/banner',
      name: 'banner',
      component: resolve => require(['@/page/banner/banner'], resolve)
    },
    {
      path: '/program',
      name: 'program',
      component: resolve => require(['@/page/program/program'], resolve)
    },
    {
      path: '/project',
      name: 'project',
      component: resolve => require(['@/page/project/project'], resolve)
    },
    {
      path: '/per_fill',
      name: 'per_fill',
      component: resolve => require(['@/page/personal_data/per_fill'], resolve)
    },
    {
      path: '/count',
      name: 'count',
      component: resolve => require(['@/page/count/count'], resolve)
    },
    {
      path: '/statements',
      name: 'statements',
      component: resolve => require(['@/page/statements/statements'], resolve)
    },
    {
      path: '/calculate',
      name: 'calculate',
      component: resolve => require(['@/page/calculate/calculate'], resolve)
    },
    {
      path: '/projectDetails',
      name: 'projectDetails',
      component: resolve => require(['@/page/projectDetails/projectDetails'], resolve)
    },
    {
      path: '/invest',
      name: 'invest',
      component: resolve => require(['@/page/invest/invest'], resolve)
    },
    {
      path: '/submit',
      name: 'submit',
      component: resolve => require(['@/components/submit'], resolve)
    },
    {
      path: '/buy',
      name: 'buy',
      component: resolve => require(['@/page/buy/buy'], resolve)
    },
    {
      path: '/fill',
      name: 'fill',
      component: resolve => require(['@/page/fill/fill'], resolve)
    },
    {
      path: '/other',
      name: 'other',
      component: resolve => require(['@/page/other/other'], resolve)
    },
    {
      path: '/preview',
      name: 'preview',
      component: resolve => require(['@/page/preview/preview'], resolve)
    },
    {
      path: '/hiAgent',
      name: 'operationList',
      component: resolve => require(['@/page/helpDocument/operationList'], resolve)
    },
    {
      path: '/documentDetails',
      name: 'documentDetails',
      component: resolve => require(['@/page/helpDocument/documentDetails'], resolve)
    }
  ],
  scrollBehavior(to,from,savedPosition){
    return{x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js